// Browser shim: re-export the native FormData as the default export so that
// generated openapi-ts service code (which does `import FormData from 'form-data'`)
// gets the browser built-in instead of the Node.js `form-data` npm package.
export default FormData;
